import {defineStore} from "pinia";
import {api} from '@/api/client';
import {handleError} from "@/appdata/globals.ts";
import type {SubscriptionPlanInterface} from "@/types/auth.ts";

export const useContextDataStore = defineStore('contextData', {
    state: () => ({
        selectedElements: [] as string[],
        activeTab: null as string | null,
    }),
    actions: {
        // A new Stripe session's URL: checkout for a free user, the billing portal for a subscriber.
        // Single-use and short-lived, so it is never kept; null when it can't be created.
        async retrievePortalSession(returnUrl: string): Promise<string | null> {
            return api.post('/account/customer-portal/start', {
                returnUrl: returnUrl,
            })
                .then((response) => response.data?.url ?? null)
                .catch((error) => {
                    handleError(error)
                    return null
                })
        },
        async retrieveSubscriptionMetadata(returnUrl: string) {
            return api.get('/account/subscription')
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    handleError(error)
                })
        },
        // The subscription on sale, as a plan; null for a subscriber or when it can't be fetched.
        async retrieveUpgradePlan(): Promise<SubscriptionPlanInterface | null> {
            return api.get('/account/upgrade')
                .then((response) => response.data?.plan ?? null)
                .catch((error) => {
                    handleError(error)
                    return null
                })
        },
    }
})
